import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { ILayoutStore } from '../../store/LayoutStore'
import { LOADER_STATUS_IDLE, LOADER_STATUS_LOADING } from '../../store/LayoutStore'

interface ILoaderProps {
  LayoutStore?: ILayoutStore
}

@inject('LayoutStore')
@observer
class Loader extends React.Component<ILoaderProps> {
  public constructor(props: ILoaderProps) {
    super(props)
  }

  public render() {
    let status = ''
    switch (this.props.LayoutStore!.loaderStatus) {
      case LOADER_STATUS_LOADING:
        status = 'loading'
        return (
          <div className="control-color-wrapper">
            <div className="Loader">
              <p className="Loader-hiddenText">{status}</p>
              <div className="Loader-dots">
                <div />
                <div />
                <div />
              </div>
            </div>
          </div>
        )
        break
      case LOADER_STATUS_IDLE:
      default:
        status = 'idle'
        return ''
        break
    }
  }
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.tsx